// Where the same webapp bundle is running: a plain browser, an installed PWA,
// or inside the M1 Capacitor native wrapper. Install affordances surface only in
// "browser"; they are suppressed in "native" and "installed". See plans/M3.

export type AppContext = "native" | "installed" | "browser";
export type InstallTarget = "desktop" | "ios-safari" | "android-chrome" | "other";

export interface InstallEnv {
  /** Capacitor reports a native platform (M1 APK). */
  capacitorNative: boolean;
  /** Running as an installed/standalone PWA (display-mode standalone or iOS navigator.standalone). */
  standalone: boolean;
  userAgent: string;
  /** A fine pointer (mouse/trackpad) — used to tell desktop from touch. */
  pointerFine: boolean;
}

export function resolveContext(env: InstallEnv): AppContext {
  if (env.capacitorNative) return "native";
  if (env.standalone) return "installed";
  return "browser";
}

export function resolveTarget(env: InstallEnv): InstallTarget {
  const ua = env.userAgent.toLowerCase();
  if (ua.includes("android")) return "android-chrome";
  if (/iphone|ipad|ipod/.test(ua)) return "ios-safari";
  if (env.pointerFine) return "desktop";
  return "other";
}

/** Read the live environment from globals (browser). */
export function readEnv(): InstallEnv {
  const g = globalThis as unknown as {
    Capacitor?: { isNativePlatform?: () => boolean };
    matchMedia?: (q: string) => { matches: boolean } | undefined;
    navigator?: { userAgent?: string; standalone?: boolean };
  };
  const standalone =
    g.matchMedia?.("(display-mode: standalone)")?.matches === true ||
    g.navigator?.standalone === true;
  return {
    capacitorNative: g.Capacitor?.isNativePlatform?.() === true,
    standalone,
    userAgent: g.navigator?.userAgent ?? "",
    pointerFine: g.matchMedia?.("(pointer: fine)")?.matches === true,
  };
}

export function appContext(env: InstallEnv = readEnv()): AppContext {
  return resolveContext(env);
}

export function installTarget(env: InstallEnv = readEnv()): InstallTarget {
  return resolveTarget(env);
}
